import { Navbar, Footer } from "@/components/site-chrome";
import { SchoolCatchmentMap } from "@/features/school-catchments";

export function CatchmentsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mx-auto max-w-[1400px] px-4 pt-28 pb-16 sm:px-6">
        <SchoolCatchmentMap />
      </div>
      <Footer />
    </div>
  );
}
